import { render, staticRenderFns } from "./FormBuilderCreate.vue?vue&type=template&id=783151cb&"
import script from "./FormBuilderCreate.vue?vue&type=script&lang=js&"
export * from "./FormBuilderCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports